import { defineMessages } from 'react-intl';

export const ratingsOverviewMessages = defineMessages({
  label: {
    id: 'customerRatings.ratingsOverview.label',
    defaultMessage: '{rating, plural, one {# Stern} other {# Sterne}}',
  },
});
